import { FinancialsRowValue } from './types'

export function getYoYData<T extends FinancialsRowValue>(data: T[]) {
  const sortedData = [...data].sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year))
  return sortedData.reduce<{
    change: Record<string, number | null>
    changePct: Record<string, number | null>
  }>(
    (acc, { year, value }, i) => {
      const prev = sortedData[i - 1]?.value ?? null
      let change: number | null = null
      let changePct: number | null = null

      if (value !== null && prev !== null && value !== 0 && prev !== 0) {
        change = value - prev
        changePct = ((value - prev) / Math.abs(prev)) * 100
      }

      return {
        change: {
          ...acc.change,
          [year]: change,
        },
        changePct: {
          ...acc.changePct,
          [year]: changePct,
        },
      }
    },
    { change: {}, changePct: {} }
  )
}

export function getIsCompact(numOfCols: number, barWidth: number) {
  // ~1400 is max container width
  const maxContainerWidth = Math.min(window.innerWidth, 1400)

  const barsWindowWidthRatio = (barWidth * numOfCols) / maxContainerWidth
  return barsWindowWidthRatio > 0.65
}
